<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="data"
      item-key="_id"
      class="elevation-1"
      :footer-props="{
        'items-per-page-options': [10, 20, 50, 100, 200, 500]
      }"
      :items-per-page="100"
    />
  </div>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import moment from 'moment';

export default {
    name: "Admin",
    data: () => ({
        headers: [
            { text: 'Data', value: 'data', },
            { text: 'Contactes', value: 'contactes' },
            { text: 'Videos', value: 'videos' }
        ],
        data: []
    }),
    created () {
        this.fetch();
    },
    methods: {
        fetch () {
            ApiRepository.contacts().then((res) => {
                this.data = [];
                for (const item of res.data) {
                    item.data = moment(item.data).format("DD/MM/YYYY");
                    this.data.push(item);
                }
            });
        },
    }
};
</script>

<style scoped>

</style>
